
import { useContext } from "react";
import { SignupContext } from "../../providers/signupProvider";
import "./signup-stage-header.scss";


const SignupStageHeader : React.FC = () =>{

    const {currentStep } = useContext(SignupContext);
    return (
        <div className="signup-stage-header-wrapper wizard">
            <div className={`wizard__circle ${(currentStep == 'BASIC' || currentStep == 'COMPANY' || currentStep == 'COMPANY_MORE') ? 'completed': ''}`}>✓</div>
            <div className="wizard__hline"></div>
            <div className={`wizard__circle ${(currentStep == 'COMPANY' || currentStep == 'COMPANY_MORE') ? 'completed': ''}`}>2</div>
            <div className="wizard__hline"></div>
            <div className={`wizard__circle ${(currentStep == 'COMPANY_MORE') ? 'completed': ''}`}>3</div>
            <div className="wizard__hline"></div>
            <div className={`wizard__circle ${(currentStep == 'COMPANY_DEEP') ? 'completed': ''}`}>4</div>        
        </div>
    );
};

export default SignupStageHeader;